import { Tooltip } from 'antd';
import { ReactNode } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { Customer, DutyPayer, VatTreatment } from 'store/customers/customer';
import { hasBillingDetails } from 'views/customers/utils';

export const getCustomerNotifications = (record: Customer) => {
    const notifications: ReactNode[] = [];

    if (!hasBillingDetails(record)) {
        notifications.push(
            <Tooltip key="billing-details-missing" title="Billing details missing.">
                <WarningFilled style={{ color: 'var(--warning-normal)' }} />
            </Tooltip>
        );
    }

    return notifications;
};

export const getVatTreatment = (record: Customer): string | undefined => {
    const { vatTreatment } = record.customerDetails ?? {};

    if (!vatTreatment) {
        return undefined;
    }

    return vatTreatment === VatTreatment.POSTPONED ? 'Postponed VAT' : 'Standard VAT';
};

export const getDutyPayer = (record: Customer): string | undefined => {
    const { dutyPayer } = record.customerDetails ?? {};

    if (!dutyPayer) {
        return undefined;
    }

    return dutyPayer === DutyPayer.CONSIGNEE ? 'Consignee Pays Duty' : 'Declarant Pays Duty';
};
